import { fetchQuestionnaire } from "api"
import { TypographyV2 } from "components/v2"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useCurrentPreferences } from "store/hooks"
import { getQuestionResponseComponent } from "./getQuestionResponseComponent"
import { ChevronUpIcon } from "@heroicons/react/24/outline"

const CardQuestionnaireResponse = ({ question, screeningAnswers }: { question: any; screeningAnswers: any }) => {
    const [subQuestions, setSubQuestions] = useState<any[]>([])
    const [questionnaireTitle, setQuestionnaireTitle] = useState("")
    const dateFormat = useCurrentPreferences()?.date_format
    const { i18n } = useTranslation()
    const [isCollapsed, setIsCollapsed] = useState(false)
    const questionnaireId = question.definition?.questionnaire_id

    useEffect(() => {
        const getQuestionnaireDetails = async () => {
            if (questionnaireId) {
                const questionnaire = await fetchQuestionnaire(questionnaireId)
                setSubQuestions(questionnaire.questions || [])
                setQuestionnaireTitle(questionnaire.title || question?.question)
            }
        }
        getQuestionnaireDetails()
    }, [questionnaireId, question])

    return (
        <div className="space-y-4">
            <div className="flex justify-between" onClick={() => setIsCollapsed(!isCollapsed)}>
                <TypographyV2 type="lg" width="semibold" className="text-[#111827]">
                    {questionnaireTitle}
                </TypographyV2>
                <ChevronUpIcon
                    className="w-6 h-6"
                    style={{ transform: isCollapsed ? "rotate(180deg)" : "rotate(0deg)" }}
                />
            </div>
            {isCollapsed &&
                subQuestions.map((subQuestion: any, index: number) => {
                    const answer = screeningAnswers?.responses?.find((a: any) => a.question_id === subQuestion.id)

                    return (
                        <div key={`subQuestion_${index}`} className="ml-4">
                            {getQuestionResponseComponent(
                                subQuestion,
                                answer,
                                index,
                                dateFormat,
                                i18n,
                                screeningAnswers
                            )}
                        </div>
                    )
                })}
        </div>
    )
}

export default CardQuestionnaireResponse
